import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import ComponentWrapper from '../../common/ContentWrapper';
import ImageWithFallback from '../../common/ImageWithFallback';
import testIds from './testIds';
import { REGIONS } from '../../../core/japaneseRegions';

const DESIRED_REGION_ORDER = [
  'kanto',
  'chubu',
  'kinki',
  'hokkaido',
  'chugoku',
  'tohoku',
  'shikoku',
  'kyushu',
  'okinawa',
];

const REGIONS_MAPPING: Record<string, (typeof REGIONS)[number]> = REGIONS.reduce((acc, region) => {
  Object.assign(acc, { [region.path]: region });
  return acc;
}, {});

type PrefectureImageProps = {
  alt: string;
  path?: string;
  imgSrc: string;
  title: string;
  width: number;
  height: number;
  searchQuery: string;
};

const RegionImage = ({
  alt,
  imgSrc,
  title,
  width,
  height,
  path,
  searchQuery,
}: PrefectureImageProps) => {
  return (
    <div className="relative flex flex-col gap-2">
      <ImageWithFallback
        alt={alt}
        className="rounded-lg"
        src={imgSrc}
        objectFit="cover"
        url={`/search/region/${path}?${searchQuery}`}
        layout="fixed"
        width={width}
        height={height}
        fallbackSrc="/fallback-img-3704x2304.png"
        sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 320px"
      />
      <h3 className="line-clamp-2 text-center text-base font-normal text-gray-950">
        {/* remove '地域' keyword from region title */}
        {title.split('・')[0]}
      </h3>
    </div>
  );
};

const RegionsList = ({ searchQuery }: { searchQuery: string }) => {
  const { t } = useTranslation('home');

  return (
    <ComponentWrapper className="pt-4">
      <div className="flex justify-between gap-3 overflow-x-auto" data-testid={testIds.images}>
        {DESIRED_REGION_ORDER.map((name) => {
          const region = REGIONS_MAPPING[name];

          return (
            <RegionImage
              key={region?.name}
              path={region?.path}
              imgSrc={`/newRegionImages${region?.image}`}
              alt={t(region?.alt || '')}
              width={112}
              height={112}
              title={t(region?.title || '')}
              searchQuery={searchQuery}
            />
          );
        })}
      </div>
    </ComponentWrapper>
  );
};

export default memo(RegionsList);
